module.exports = __webpack_public_path__ + "static/img/19.363457a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/19.png
// module id = zQ+D
// module chunks = 0